import { PlaceholdersId, TFComponent } from '@types';

import { ResumeAndAuthorizationPlaceholder } from './resumeAndAuthorization';

export const resumeAndAuthorization: TFComponent = {
	component: ResumeAndAuthorizationPlaceholder,
	id: PlaceholdersId.resumeAndAuthorization,
	name: 'resumeAndAuthorization',
};
